import { useTranslation } from "react-i18next";
import { VideoCameraIcon, MapPinIcon, CheckIcon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export function ModalityStep({
  selected,
  officeAddress,
  onSelect,
}: {
  selected: "online" | "in_person" | null;
  officeAddress?: string | null;
  onSelect: (m: "online" | "in_person") => void;
}) {
  const { t } = useTranslation();

  const options = [
    {
      id: "online" as const,
      icon: VideoCameraIcon,
      title: t("booking.modalityOnline"),
      desc: t("booking.modalityOnlineDesc"),
    },
    {
      id: "in_person" as const,
      icon: MapPinIcon,
      title: t("booking.modalityInPerson"),
      desc: officeAddress || t("booking.modalityInPersonDesc"),
    },
  ];

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {options.map((opt) => {
        const active = selected === opt.id;
        return (
          <button
            key={opt.id}
            data-testid={`booking-modality-${opt.id}`}
            onClick={() => onSelect(opt.id)}
            className={cn(
              "flex items-start gap-3 rounded-2xl border bg-card p-4 text-left transition-all",
              active ? "border-foreground ring-1 ring-foreground" : "border-border/70 hover:border-primary",
            )}
          >
            <span className="grid size-9 shrink-0 place-items-center rounded-xl bg-muted/50">
              <opt.icon className="size-[18px] text-foreground" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between text-[15px] font-semibold text-foreground">
                {opt.title}
                {active && (
                  <span className="grid size-5 place-items-center rounded-full bg-foreground">
                    <CheckIcon className="size-3 text-background" weight="bold" />
                  </span>
                )}
              </span>
              <span className="mt-0.5 block text-[13px] text-muted-foreground">{opt.desc}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
